<template>
	<v-ons-page>
		<v-ons-splitter>

			<v-ons-splitter-side :open.sync="isOpen" :swipe-target-width="50" collapse="" side="right" :swipeable="isMenuAvailable">
				<main-menu></main-menu>
			</v-ons-splitter-side>

			<v-ons-splitter-content>
				<app-navigator></app-navigator>
			</v-ons-splitter-content>

		</v-ons-splitter>
		<transition name="fade">
			<div v-if="reminderVisible" class="toast toast--material qf-session-toast">
				<transition name="fade">
					<div v-if="reminderTextVisible" class="toast__message toast--material__message" key="intro">
						<v-ons-icon icon="fa-clock"></v-ons-icon>
						{{bannerMsg}} <span v-if="bannerState!==2">{{this.remSessionTime}}</span>
					</div>
				</transition>
				<transition name="fade">
					<button key="refreshBtn" v-if="reminderTextVisible && extendBtnVisible"
						class="toast__button toast--material__button" @click="extendSession"><strong>Extend</strong>
					</button>
				</transition>
				<transition>
					<span v-if="!reminderTextVisible" class="toast__message toast--material__message" key="standby">
						Extending session...
					</span>
				</transition>
			</div>
		</transition>
		<transition name="fade">
			<div v-if="updateExists" class="toast toast--material qf-session-toast">
				<div class="toast__message toast--material__message">
					New version available! Please, tap update to download it.
				</div>
				<button class="toast__button toast--material__button" @click="refreshApp"><strong>Update</strong>
				</button>
			</div>
		</transition>
	</v-ons-page>
</template>

<script>
	import MainMenu from "./common/MainMenu";
	import AppNavigator from "./AppNavigator";
	import Login from "./views/login/Login";
	import moment from 'moment';
	//import api from "./services/api";
    import ApiFormData from "./services/apiFormData";

	export default {
		data() {
			return {
				remSessionSeconds: 7200,
				remSessionTime: '',
				reminderVisible: false,
				reminderTextVisible: true,
				extendBtnVisible: false,
				timerIsOn: false,
				bannerState: 1,
				timeToHide: false,
				isExtending: false,
				//SW Stuff
				refreshing: false,
				registration: null,
				updateExists: false,
			}
		},
		beforeMount() {
			const html = document.documentElement;
			if (this.$ons.platform.isIPhoneX()) {
				html.setAttribute('onsflag-iphonex-portrait', '');
				html.setAttribute('onsflag-iphonex-landscape', '');
			}
		},
		created() {
			document.addEventListener(
				'swUpdated', this.showRefreshUI, { once: true }
			);
			if(navigator.serviceWorker){
				navigator.serviceWorker.addEventListener(
					'controllerchange', () => {
						if (this.refreshing) return;
						this.refreshing = true;
						window.location.reload();
					}
				);
			}
		},
		mounted() {

		},
		methods: {
			showRefreshUI (e) {
				this.registration = e.detail;
				this.updateExists = true;
			},
			refreshApp () {
				this.updateExists = false;  if (!this.registration || !this.registration.waiting) { return; }
				this.registration.waiting.postMessage('skipWaiting');
			},
			onTimesUp() {
				clearInterval(this.timerInterval);
				console.log("Timer stop");
				this.goToLogin();
			},
			goToLogin(){
				this.$deleteCookie('access_token');
				this.$deleteCookie('refresh_token');
				this.$deleteCookie('access_exp_time');
				this.timerIsOn = false;
				this.reminderVisible = false;
				this.$store.commit('navigator/reset');
				this.$store.commit('navigator/push', {
					extends: Login,
					data() {
						return {
							bounced: true
						};
					}
				});
			},
			extendSession() {
				this.reminderTextVisible = false;
				this.extendBtnVisible = false;
				this.isExtending = true;
				let self = this;

                let payload = new FormData();
                payload.append('grant_type', 'refresh_token');
                payload.append('client_id', process.env.VUE_APP_CLIENT_ID);
                payload.append('client_secret', process.env.VUE_APP_CLIENT_SECRET);
                payload.append('refresh_token', this.$getCookie('refresh_token'));

				setTimeout(function () {
                    ApiFormData().post('oauth/v2/token', payload).then((response) => {
						let now = moment(new Date());
						let extensionTime = 1200;
						if (extensionTime < response.data.expires_in) extensionTime = response.data.expires_in;

						self.$setCookie('access_token', response.data.access_token, response.data.expires_in+30);
						self.$setCookie('refresh_token', response.data.refresh_token, 7200);
						self.$setCookie('access_exp_time', now.unix() + extensionTime, 14*14400);
						//console.log("Tokens refreshed!");
						clearInterval(self.timerInterval);
						self.startTimer();
						self.reminderTextVisible = true;
						setTimeout(function () {
							self.reminderVisible = false;
							self.isExtending = false;
						}, 4000);
					}).catch(() => {

					});
				}, 2000);

			},
			startTimer() {
				this.timerIsOn = true;
				console.log("Timer Start!");
				let expUnix = this.$getCookie('access_exp_time');
				if (expUnix) {
					let now = moment(new Date());
					let expirationDate = moment.unix(expUnix);
					this.remSessionSeconds = expirationDate.diff(now, 'seconds');
					//console.log('Exp date: ', expirationDate.format('YYYY-MM-DD HH:mm'));
					if (this.remSessionSeconds > 0) {
						this.timerInterval = setInterval(() => {
							this.remSessionSeconds = expirationDate.diff(new Date(), 'seconds'); //Required here again because of situation where device goes to sleep and timer is already triggered but becomes unreliable during sleep
							this.remSessionSeconds -= 1;
							this.remSessionTime = moment.utc(moment.duration(this.remSessionSeconds, "seconds").asMilliseconds()).format("HH:mm:ss");
							//console.log(this.remSessionTime);
						}, 1000);
					}

				} else {
					console.log('No access_exp_time cookie ');
				}
			},
			showPopTip() {
				let self = this;
				this.$ons.notification.toast({
					message: 'Time remaining on your session: ' + self.remSessionSeconds,
					buttonLabel: 'Extend',
					//timeout: 9000
				}).then(() => {

				});
			}
		},
		computed: {
			currTimeRemaining() {
				return this.remSessionSeconds;
			},
			bannerMsg() {
				let txt = '';
				switch (this.bannerState) {
					case 1 :
						txt = 'Time remaining on your session:';
						break;
					case 2 :
						txt = 'Extending your session...';
						break;
					case 3 :
						txt = 'Session extended for another ';
						break;
				}
				return txt;
			},
			bannerVisible() {
				if (this.remSessionSeconds > 180 || !this.timerIsOn || this.isLoginActive || this.timeToHide) {
					return false;
				} else if (this.remSessionSeconds < 180) {
					return true;
				} else {
					return false;
				}
			},
			isLoginActive: {
				get() {
					//return AppNavigator.methods.getCurrentPage();
					if (this.$store.state.navigator.stack[0]) {
						return this.$store.state.navigator.stack[0].name;
					} else {
						return 'loading';
					}
				}
			},
			isMenuAvailable() {
				return this.$store.state.shared.startTimer;
			},
			isOpen: {
				get() {
					return this.$store.state.splitter.open;
				},
				set(newValue) {
					this.$store.commit('splitter/toggle', newValue)
				}
			},
			shouldTimerStart() {
				return this.$store.state.shared.startTimer;
			}
		},
		components: {
			AppNavigator,
			MainMenu,
		},
		watch: {
			remSessionSeconds(newval) {
				//console.log(this.remSessionTime);
				if (newval < 120) {
					if (newval <= 0) {
						this.onTimesUp();
					}else{
						this.reminderVisible = true;
						if(!this.isExtending){
							this.extendBtnVisible = true;
						}
					}
				}

			},
			isLoginActive(newPage) {
				console.log("Current page:", newPage);
			},
			shouldTimerStart(shouldIt) {
				if(shouldIt && !this.timerIsOn){
					this.startTimer();
				}else if(!shouldIt && this.timerIsOn){
					this.onTimesUp();
				}
			}
		}
	};
</script>

<style>
	ons-splitter-side[animation=overlay] {
		border-left: 1px solid #bbb;
	}

	.qf-session-toast {
		background: #d68600;
	}

	.qf-session-toast .toast__message,
	.qf-session-toast .toast__button {
		color: white;
	}

	.fade-enter-active, .fade-leave-active {
		transition: opacity .5s;
	}

	.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
	{
		opacity: 0;
	}
	html {
		height: calc(100vh - 1px) !important;
		overflow: hidden !important;
	}
	body {
		height: 100%;
		position: fixed;
		background-color: #212121;
	}
	.bg-login:after {
		content: '';
		background-image: url('assets/img/background.png');
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-size: 100%;
		background-position: bottom center;
		background-repeat: no-repeat;
	}
	/*
	.toolbar.toolbar--material+.page__background+.page__content,
	.tabbar__content{
		padding-bottom: env(safe-area-inset-bottom) !important;;
		box-sizing: border-box;
	}
	.toolbar.toolbar--material+.page__background+.page__content,.toolbar,.menu-profil,
	.tabbar__content{
		padding-top: env(safe-area-inset-bottom) !important;
	}
	.toolbar{
		height: calc(56px + env(safe-area-inset-bottom));
	}
	.tabbar {
		height: calc(49px + env(safe-area-inset-bottom));
	}
	.tabbar__border{bottom: env(safe-area-inset-bottom)}
	*/
</style>
